/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Details_TitleInputs */

const en_matching_score_details_title = /** @type {(inputs: Matching_Score_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Score Details`)
};

const de_matching_score_details_title = /** @type {(inputs: Matching_Score_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details zum Matching-Score`)
};

/**
* | output |
* | --- |
* | "Matching Score Details" |
*
* @param {Matching_Score_Details_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_details_title = /** @type {((inputs?: Matching_Score_Details_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Details_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_details_title(inputs)
	return en_matching_score_details_title(inputs)
});